import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  input: {},
  recording: false,
  audio: {
    recording: false,
    audioUrl: "",
    friendId: null,
  }
};

const talkSlice = createSlice({
  name: "talk",
  initialState: initialState,
  reducers: {
    reset() {
      return initialState;
    },
    updateInput(state, action) {
      const { friendId, newInput } = action.payload;
      state.input[friendId] = newInput;
    },
    clearInput(state, action) {
      const { friendId } = action.payload;
      state.input[friendId] = "";
    },
    startRecording(state, action) {
      const { friendId } = action.payload;
      state.audio.friendId = friendId;
      state.audio.audioUrl = "";
      state.audio.recording = true;
    },
    setAudioUrl(state, action) {
      const { audioUrl } = action.payload;
      state.audio.audioUrl = audioUrl;
    },
    clearAudio(state) {
      state.audio.friendId = null;
      state.audio.audioUrl = "";
      state.audio.recording = false;
    }
  },
});

export const talkActions = talkSlice.actions;

export default talkSlice.reducer;
